module.exports = __webpack_public_path__ + "img/Step5.c4fe7f0a.png";